import { authHeaders } from '../../lib/authHeaders';

export interface BriefStats {
  docs_last_15d: number;
  new_leases_last_15d: number;
  new_deeds_last_15d: number;
  new_parties_last_15d: number;
  signals_last_15d: number;
  pool_orders_last_15d: number;
  parties_touched_last_15d: number;
  pinned_aoi_count: number;
}

export interface BriefAoiSnapshot {
  id: string;
  name: string;
  basin: string | null;
  trs_count: number;
  docs_last_15d: number;
  open_signals: number;
}

export interface BriefSignal {
  id: string;
  scope: 'aoi' | 'pool_order' | 'global';
  scope_id: string | null;
  signal_type: string;
  severity: number;
  headline: string;
  detail: string | null;
  cta_label: string | null;
  cta_target: string | null;
  evidence: Record<string, unknown>;
  created_at: string;
  weekly_brief_id: string | null;
  scope_label: string | null;
  pipeline_pushes: Array<{ party_id: string; pushed_at: string }>;
}

export interface BriefLastWeekly {
  id: string;
  claude_model: string;
  prompt_version: string;
  input_token_count: number | null;
  output_token_count: number | null;
  total_cost_usd: string | null;
  parse_status: 'complete' | 'failed';
  notes: string | null;
  created_at: string;
}

export interface BriefLeaseExpiring {
  doc_number: string;
  effective_date: string | null;
  primary_term_months: number | null;
  estimated_expiry: string;
  grantor_label: string | null;
  trs_label: string | null;
}

export interface BriefResponse {
  stats: BriefStats;
  pinned_aois: BriefAoiSnapshot[];
  signals: BriefSignal[];
  lead_alert_signals: BriefSignal[];
  last_weekly_brief: BriefLastWeekly | null;
  lease_expiring_soon: BriefLeaseExpiring[];
  generated_at: string;
}

export const briefApi = {
  get: async (): Promise<BriefResponse> => {
    const r = await fetch('/api/mi/brief', { credentials: 'include', headers: authHeaders() });
    if (!r.ok) {
      let detail = r.statusText;
      try { detail = (await r.json()).error ?? detail; } catch {}
      throw new Error(`${r.status} ${detail}`);
    }
    return r.json();
  },
  runWeekly: async (): Promise<{ weekly_brief_id: string; signals_inserted: number; parse_status: 'complete' | 'failed'; warnings: string[] }> => {
    const r = await fetch('/api/mi/weekly-analysis', { method: 'POST', credentials: 'include', headers: authHeaders() });
    if (!r.ok) {
      let detail = r.statusText;
      try { detail = (await r.json()).error ?? detail; } catch {}
      throw new Error(`${r.status} ${detail}`);
    }
    return r.json();
  },
};
